// extracted by mini-css-extract-plugin
module.exports = {"sliderContainer":"GroupPhotos_sliderContainer__30FAF","groupPhotoItem":"GroupPhotos_groupPhotoItem__1dBMs"};